// @flow
import React, { useMemo } from 'react';

import months from './months';
import PlainSelect from './PlainSelect';
import type { OnChangeFunc } from './PlainSelect';

type Props = {
  onChange: OnChangeFunc,
  name?: string,
  current?: string,
  startDate?: string,
  finishDate?: string,
  label?: string,
  hideErrorString?: boolean,
}

const PlainSelectMonth = ({
  onChange,
  name = 'month',
  current,
  startDate,
  finishDate,
  label = '',
  hideErrorString,
}: Props) => {
  // данные для списка
  // id: 'YYYY-MM'
  // title: 'MMMM YYYY'

  // $FlowFixMe
  const data = useMemo(() => ([...months({
    start: startDate,
    finish: finishDate,
  })]), [startDate, finishDate]);

  return (
    <PlainSelect
      label={label}
      data={data}
      name={name}
      current={current}
      placeholder="Выберите..."
      onChange={onChange}
      hideErrorString={hideErrorString}
      uni
    />
  );
};

export default PlainSelectMonth;
